import React, { useEffect } from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getLayout } from 'components/layouts/Header';
import WelcomePopup from 'components/candidate/WelcomePopup/WelcomePopup.component';
import { onboardingPopupModalInstance } from 'components/candidate/Onboarding/OnboardingPopupModal';
import { withAuthCandidate } from 'lib/hocs/withAuthCandidate';
import { useAuth } from 'lib/providers/AuthProvider';
import { PAGE_ROUTES } from 'lib/page-routes';
import Dashboard from './Dashboard';
import DashboardBanner from './DashboardBanner';

import styles from './Section.module.scss';

const Matches: React.FC = () => {
  const router = useRouter();
  const { isTemporaryCandidate, isAuthLoading, isNonOnboardedUser } = useAuth();

  if (isTemporaryCandidate) {
    router.replace(PAGE_ROUTES.CANDIDATE_SIGN_IN);
  }

  const onCloseWelcomePopup = () => {
    router.replace(
      `${PAGE_ROUTES.CANDIDATE_DASHBOARD}?showWelcomePopup=false`,
      PAGE_ROUTES.CANDIDATE_DASHBOARD
    );
  };
  useEffect(() => {
    router.prefetch(PAGE_ROUTES.CANDIDATE_ONBOARDING);
  }, []);

  /** Open Onboarding popup if user is non onboarded */
  useEffect(() => {
    if (isNonOnboardedUser && !isAuthLoading) {
      (async () => {
        try {
          await onboardingPopupModalInstance();
        } catch (error) {
          console.error(error);
        }
      })();
    }
  }, [isNonOnboardedUser, isAuthLoading]);

  return (
    <>
      <DashboardBanner className={cn(styles.hideMobile)} />
      <Dashboard />
      {router?.query?.showWelcomePopup === 'true' && (
        <WelcomePopup onClose={onCloseWelcomePopup} />
      )}
    </>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'candidate-dashboard',
        'candidate-onboarding',
        'matches',
      ])),
    },
  };
}

const MatchesWrapper = withAuthCandidate(Matches);
// @ts-ignore
MatchesWrapper.getLayout = getLayout.bind();

export default MatchesWrapper;
